export default __webpack_public_path__ + "static/media/instagram.b2614d0a.svg";